<template>
  <div class="px-3">
    <VaDatePicker v-model="countdownData.selectedDate" :label="'Last day for counting'"></VaDatePicker>
    <VaColorPicker :position="'bottom'" :title="'Timer color'" v-model="countdownData.timerColor"></VaColorPicker>
  </div>
</template>

<script>
  import VaDatePicker from "@/components/custom/VaDatePicker.vue";
  import VaColorPicker from "@/components/custom/VaColorPicker.vue";
  export default {
    name: "CountdownDialog",
    components: {
      VaDatePicker,
      VaColorPicker,
    },
    data() {
      return {
        countdownData: {
          selectedDate: "",
          timerColor: "#1C42BE",
        },
      };
    },
    computed: {},
    watch: {
      countdownData: {
        handler(newValue) {
          this.updateValue(newValue);
        },
        deep: true,
      },
    },
    beforeMount() {
      this.setupReceiveDataListener();
      this.requestData();
    },
    mounted() {},
    methods: {
      updateValue(val) {
        window.parent.postMessage(
          {
            mceAction: "updateCountdownData",
            data: val,
          },
          origin,
        );
      },
      setupReceiveDataListener() {
        window.onmessage = message => {
          if (message.data.type === "sendData") {
            const { data } = message.data;

            this.countdownData = data;
          }
        };
      },
      requestData() {
        window.parent.postMessage(
          {
            mceAction: "requestData",
          },
          origin,
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";
</style>
